import React, { useEffect } from 'react';
import { Card, Input, Row, Col, Tag, Badge } from 'antd';
import dayjs from 'dayjs';
import { MethodType, useApi } from '../../helpers/apiClient';
import { useParams } from 'react-router';
import Loader from '../../common_components/Loader';

const providerColor = {
    google: 'blue',
    local: 'green',
};

const labelStyle = { fontWeight: 500, marginBottom: 2, display: 'block' };
const valueStyle = { marginBottom: 12 };

const UserDetail = () => {
    // eslint-disable-next-line no-unused-vars
    const { callApi, loading, error, data } = useApi();
    const { id } = useParams();
    useEffect(() => {
        callApi(MethodType.GET, `/admin/users/${id}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const user = data?.data?.user || {}


    if (loading) {
        return <Loader />;
    }


    // You may want to fetch user data by id from route params here
    return (
        <Card title="User Detail" bordered={false} style={{ maxWidth: 700, margin: '0 auto' }}>
            <Row gutter={[16, 8]}>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Full Name</span>
                    <Input value={user.fullName || ''} readOnly size="small" style={valueStyle} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Email</span>
                    <Input value={user.email || ''} readOnly size="small" style={valueStyle} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Username</span>
                    <Input value={user.username || ''} readOnly size="small" style={valueStyle} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Bio</span>
                    <Input value={user.bio || ''} readOnly size="small" style={valueStyle} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Link</span>
                    {user.link ? (
                        <Input value={user.link} readOnly size="small" style={valueStyle} addonAfter={<a href={user.link} target="_blank" rel="noopener noreferrer">Visit</a>} />
                    ) : (
                        <Input value="-" readOnly size="small" style={valueStyle} />
                    )}
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Gender</span>
                    <Input value={user.gender || ''} readOnly size="small" style={valueStyle} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Birthdate</span>
                    <Input value={user.birthdate ? dayjs(user.birthdate).format('DD/MM/YYYY') : ''} readOnly size="small" style={valueStyle} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Auth Provider</span>
                    <Input value={user.authProvider || ''} readOnly size="small" style={valueStyle} addonAfter={user.provider ? <Tag color={providerColor[user.provider] || 'default'}>{user.provider}</Tag> : null} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Is Creator</span>
                    <Input value={user.isCreator ? 'Yes' : 'No'} readOnly size="small" style={valueStyle} addonAfter={<Badge status={user.isCreator ? 'success' : 'default'} />} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Posts Count</span>
                    <Input value={user.postsCount ?? user.posts?.length ?? 0} readOnly size="small" style={valueStyle} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Products Count</span>
                    <Input value={user.productsCount ?? user.products?.length ?? 0} readOnly size="small" style={valueStyle} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Email Verified</span>
                    <Input value={user.isEmailVerified ? 'Verified' : 'Not Verified'} readOnly size="small" style={valueStyle} addonAfter={<Tag color={user.isEmailVerified ? 'green' : 'red'}>{user.isEmailVerified ? 'Verified' : 'Not Verified'}</Tag>} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Created At</span>
                    <Input value={user.createdAt ? dayjs(user.createdAt).format('DD/MM/YYYY HH:mm') : ''} readOnly size="small" style={valueStyle} />
                </Col>
                <Col xs={24} sm={12} md={8}>
                    <span style={labelStyle}>Updated At</span>
                    <Input value={user.updatedAt ? dayjs(user.updatedAt).format('DD/MM/YYYY HH:mm') : ''} readOnly size="small" style={valueStyle} />
                </Col>
            </Row>
        </Card>
    );
};

export default UserDetail;